(function () {
  'use strict';
  function searchQuery(product, model, details) {
    return [product, model, details, 'compatibility manufacturer specifications']
      .map(value => String(value || '').trim()).filter(Boolean).join(' ');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {searchQuery};
  if (typeof document === 'undefined') return;
  if (window.tekCompatibilityLoaded) return;
  const dialog = document.getElementById('tp-compatibility-dialog');
  if (!dialog) return;
  window.tekCompatibilityLoaded = true;
  const form = dialog.querySelector('form');
  const model = dialog.querySelector('#tp-system-model');
  const details = dialog.querySelector('#tp-system-details');
  const query = dialog.querySelector('#tp-compatibility-query');
  const output = dialog.querySelector('[data-compatibility-result]');
  let activeButton = null, product = '';
  function resetResult() { output.hidden = true; output.replaceChildren(); query.value = ''; }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-tp-compatibility]');
    if (!button) return;
    event.preventDefault();
    activeButton = button;
    product = button.dataset.productTitle || 'Selected part';
    dialog.querySelector('[data-compatibility-product]').textContent = product;
    model.setCustomValidity('');
    resetResult(); dialog.showModal(); model.focus();
  });
  dialog.querySelector('[data-compatibility-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { if (activeButton?.isConnected) activeButton.focus(); });
  model.addEventListener('input', () => { model.setCustomValidity(''); resetResult(); });
  details.addEventListener('input', resetResult);
  form.addEventListener('submit', event => {
    if (model.value.trim().length < 3) {
      event.preventDefault();
      model.setCustomValidity('Enter your system brand and exact model.'); model.reportValidity(); return;
    }
    query.value = searchQuery(product, model.value, details.value);
    output.replaceChildren();
    const heading = document.createElement('h3');
    heading.textContent = 'Verify compatibility before ordering';
    const text = document.createElement('p');
    text.textContent = 'Compare the exact model, form factor, connections, and any BIOS or power requirements with the manufacturer’s documentation. A similar model name does not confirm a fit.';
    const link = document.createElement('a');
    link.textContent = 'Open this Google search again';
    link.href = 'https://www.google.com/search?q=' + encodeURIComponent(query.value);
    link.target = '_blank'; link.rel = 'noopener noreferrer';
    output.append(heading, text, link); output.hidden = false;
    // Native form submission opens Google. No customer information is stored.
  });
})();
